<ngb-accordion activeIds="ngb-panel-0" closeOthers="true">

  <ngb-panel  *ngFor="let serviceGroup of serviceGroupings">
      <ng-template ngbPanelTitle>
        <b>{{serviceGroup.title}}</b>
      </ng-template>
      <ng-template ngbPanelContent>
        <p>{{serviceGroup.description}}</p>

        <ul>
          <li *ngFor="let service of serviceGroup.services">
            {{service.title}} <span *ngIf="service.description">-</span> {{service.description}}
          </li>
        </ul>

      </ng-template> 
  </ngb-panel>
  
</ngb-accordion>
